import { render, staticRenderFns } from "./customerCandidatePlacing.vue?vue&type=template&id=19751a8c&"
import script from "./customerCandidatePlacing.vue?vue&type=script&lang=js&"
export * from "./customerCandidatePlacing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports